import type { IFeaturePage } from '@/pages/tad.ai/_types/feature'
import type { FC } from 'react'

import {
  Cta,
  Features,
  Hero,
  InternalLinks,
  Overview,
  Steps,
  UserGroups,
  UserReviews,
} from '@/pages/tad.ai/_components/FeatureCms'
import { useCanonicalHref } from '@/hooks/routes'
import RatingStructured from '@/components/Structured/RatingStructured'
import { Faq } from '@/pages/tad.ai/_components/Faq'
import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'

interface FeatureSeoPageProps {
  pageData: IFeaturePage
}

/**
 * Dedicated SEO section for feature routes.
 * Reuses the CMS-driven feature template while keeping route-specific
 * function areas untouched.
 */
export const FeatureSeoPage: FC<FeatureSeoPageProps> = ({ pageData }) => {
  const [canonicalUrl] = useCanonicalHref()

  const { isSignIn } = useSessionInfo()
  if (isSignIn) {
    return null
  }

  const {
    showFunctionArea,
    faqs,
    features,
    internalLinks,
    userReviews,
    cta,
    userGroups,
    steps,
    overview,
    hero,
    title,
    description,
    ratingData,
  } = pageData
  return (
    <>
      {ratingData && (
        <RatingStructured
          name={title}
          description={description}
          origin={canonicalUrl}
          ratingValue={ratingData.ratingValue}
          reviewCount={ratingData.reviewCount}
          priceCurrency={ratingData.priceCurrency}
        />
      )}
      <div className='mx-auto max-w-[1200px] space-y-[80px] px-4 pb-[100px] pt-[68px] md:space-y-[160px] md:pt-[124px] lg:pb-[120px]'>
        {/* 功能区有h1字段，两者二选一 */}
        {!showFunctionArea && <Hero hero={hero} />}
        <Overview overview={overview} />
        <Features features={features} />
        <UserGroups userGroups={userGroups} />
        <Steps steps={steps} />
        <UserReviews userReviews={userReviews} />
        <InternalLinks data={internalLinks} />
        <Faq
          faqList={faqs?.list || []}
          isCms
          className='mx-auto max-w-[1056px] px-4'
          h2={faqs?.title}
        />
        <Cta cta={cta} />
      </div>
    </>
  )
}
